import type * as mapboxgl from "mapbox-gl";

type MapIcon = {
    file: string;
    id: string;
    size?: { width: number; height: number };
};

export async function loadMapIcons(map: mapboxgl.Map, icons: MapIcon[], size?: number): Promise<void> {
    await Promise.all(icons.map(icon => loadImageFromFile(map, icon, size)));
}

function loadImageFromFile(map: mapboxgl.Map, icon: MapIcon, size = 80): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        if (map.hasImage(icon.id)) {
            return resolve();
        }

        const { width, height } = icon.size ?? { width: size, height: size };
        const img = new Image(width, height);

        img.onload = () => {
            try {
                map.addImage(icon.id, img, { sdf: true });
                resolve();
            } catch (error) {
                reject(error);
            }
        };

        img.onerror = () => {
            reject(new Error(`Failed to load image: ${icon.id} from ${icon.file}`));
        };

        img.src = icon.file;
    });
}
